import React, { lazy, LazyExoticComponent } from "react";

const adminViews: Record<string, LazyExoticComponent<() => React.ReactNode>> = {
  "global-users": lazy(() => import("./views/globalusers/GlobalUsers")),
  /* management **/
  "all-orgs": lazy(() => import("./views/org/SearchCustomers")),
  feedback: lazy(() => import("./views/feedback/AllFeedback")),
  users: lazy(() => import("../users/AllUsers")),
  partners: lazy(() => import("./views/partner/Partners")),
  invoices: lazy(() => import("./views/invoice/AllInvoices")),
  "mail-templates": lazy(() => import("./views/mailtemplates/MailTemplates")),
  "system-prompts": lazy(() => import("./views/systemprompt/SystemPrompts")),
  products: lazy(() => import("./views/onboardingpackage/OnboardingPackages")),
  permissions: lazy(() => import("./views/addon/Permissions")),
  "role-products": lazy(() => import("./views/addon/RoleProducts")),
  "diff-templates": lazy(() => import("./views/difftemplate/AllDiffTemplates")),
  coupons: lazy(() => import("./views/coupon/AllCoupons")),
  "web-settings": lazy(() => import("./views/addon/WebSettings")),
  plans: lazy(() => import("./views/quantitylimit/QuantityLimits")),
  "all-permissions": lazy(
    () => import("./views/allpermissions/AllPermissions")
  ),
  /* developer **/
  "all-apis": lazy(() => import("./views/Apis")),
  endpoints: lazy(() => import("./views/endpoint/AllEndpoints")),
  documentations: lazy(() => import("./views/documentation/AllDocumentations")),
  "all-changelogs": lazy(() => import("./views/changelog/Changelogs")),
  "all-event-types": lazy(() => import("./views/eventtype/EventTypes")),
  webhooks: lazy(() => import("./views/webhook/AllWebhooks")),
  /* other **/
  agreements: lazy(() => import("./views/agreement/Agreements")),
  tags: lazy(() => import("./views/tag/Tags")),
  "use-cases": lazy(() => import("./views/usecase/UseCases")),
  "role-templates": lazy(() => import("./views/roletemplate/RoleTemplates")),
  interruptions: lazy(() => import("./views/interruptions/Interruptions")),
  "feature-flags": lazy(() => import("./views/featureflags/FeatureFlags")),
  "endpoints-consumption": lazy(
    () => import("./views/consumption/EndpointsConsumption.tsx")
  ),
};

export default adminViews;
